import { render, staticRenderFns } from "./prescriptionAudit.vue?vue&type=template&id=b1a2c888"
import script from "./prescriptionAudit.vue?vue&type=script&lang=js"
export * from "./prescriptionAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports